import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { AddButton } from "../../shared/FormLayout/IconButtons/AddButton";
import { ValidationMessage } from "../../shared/ValidationMessage";
import { BulkWorkorderContext } from "./BulkWorkorderContext";
import { WorkorderRow } from "./WorkorderRow";

export function WorkorderLocationsAndWorkflows() {
  const { t } = useTranslation();
  const { locationsAndWorkflows, addLocationAndWorkflowGroup } = useContext(BulkWorkorderContext);

  const { register, formState, setValue, clearErrors } = useFormContext();
  const { errors } = formState;

  register("locationsAndWorkflows", {
    value: locationsAndWorkflows,
    validate: (value) => value?.length > 0,
  });

  useEffect(() => {
    clearErrors();
    setValue("locationsAndWorkflows", locationsAndWorkflows);
  }, [locationsAndWorkflows, setValue, clearErrors]);

  return (
    <>
      <Stack spacing={2} mt={4} divider={<Divider />}>
        {locationsAndWorkflows.map((workorderLocationAndWorkflowGroup, index) => (
          <WorkorderRow
            key={workorderLocationAndWorkflowGroup.groupId}
            group={workorderLocationAndWorkflowGroup}
            index={index}
          />
        ))}
        {(!locationsAndWorkflows || locationsAndWorkflows.length === 0) && (
          <Stack alignItems="center">
            <Typography variant="caption" noWrap>
              {t("workorders.locationsEmpty")}{" "}
            </Typography>
            {errors?.locationsAndWorkflows?.type === "validate" && (
              <ValidationMessage
                invalidMessage={t("workorders.locationsEmptyValidation")}
                validationType="error"
                showIcon
              />
            )}
          </Stack>
        )}
        <Box display="flex" justifyContent="center">
          <AddButton onClick={addLocationAndWorkflowGroup} />
        </Box>
      </Stack>
    </>
  );
}
